import React, { PropsWithChildren } from "react";
import styles from "./filters-bar.module.scss";

interface IFiltersBarProps {
  title?: string;
}

export function FiltersBar(props: PropsWithChildren<IFiltersBarProps>) {
  return (
    <div className={styles.root} data-testid="filters-bar">
      {props.title && (
        <div data-testid="title" className={styles["title"]}>
          {props.title}
        </div>
      )}
      {props.children && (
        <div className={styles.bar}>
          {props.children}
        </div>
      )}
    </div>
  );
};